import { render, staticRenderFns } from "./TypeOptionsAddon.vue?vue&type=template&id=19ff705a&"
import script from "./TypeOptionsAddon.vue?vue&type=script&lang=js&"
export * from "./TypeOptionsAddon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports